import i18n from "@/i18n/i18n";
import { START_GRADING_SCENARIO_STEPS } from "@/init/onboarding/scenarios/start-grading";

const RUBRIC_LIBRARY_SCENARIO_STEPS = {
  get createRubricSidePanel() {
    return {
      element: "[data-testid='rubric-library-create-new-rubric-button']",
      popover: {
        title: i18n.t("onboarding.rubricLibrary.createRubric.title"),
        description: i18n.t(
          "onboarding.rubricLibrary.createRubric.description"
        ),
        side: "left",
        align: "start",
      },
    };
  },
  get platformTab() {
    return {
      element: ".rubrics-tabs-platform",
      popover: {
        title: i18n.t("onboarding.rubricLibrary.platformTab.title"),
        description: i18n.t("onboarding.rubricLibrary.platformTab.description"),
        side: "bottom",
        align: "center",
      },
    };
  },
  get myRubricTab() {
    return {
      element: ".rubrics-tabs-my-rubric",
      popover: {
        title: i18n.t("onboarding.rubricLibrary.myRubricTab.title"),
        description: i18n.t("onboarding.rubricLibrary.myRubricTab.description"),
        side: "bottom",
        align: "center",
      },
    };
  },
};

const RUBRIC_LIBRARY_SIDEBAR_STEPS = {
  get platformTab() {
    return {
      element: "#rubric-library-sidebar .rubrics-tabs-platform",
      popover: RUBRIC_LIBRARY_SCENARIO_STEPS.platformTab.popover,
    };
  },
  get createRubricSidePanel() {
    return {
      element:
        "#rubric-library-sidebar [data-testid='rubric-library-create-new-rubric-button']",
      popover: RUBRIC_LIBRARY_SCENARIO_STEPS.createRubricSidePanel.popover,
    };
  },
  get myRubricTab() {
    return {
      element: "#rubric-library-sidebar .rubrics-tabs-my-rubric",
      popover: RUBRIC_LIBRARY_SCENARIO_STEPS.myRubricTab.popover,
    };
  },
};

const RUBRIC_LIBRARY_SCENARIO_SIDEBAR = {
  get steps() {
    return [
      RUBRIC_LIBRARY_SIDEBAR_STEPS.platformTab,
      RUBRIC_LIBRARY_SIDEBAR_STEPS.createRubricSidePanel,
      RUBRIC_LIBRARY_SIDEBAR_STEPS.myRubricTab,
    ];
  },
};

const RUBRIC_LIBRARY_SCENARIO_PAGE = {
  get steps() {
    return [
      RUBRIC_LIBRARY_SCENARIO_STEPS.platformTab,
      RUBRIC_LIBRARY_SCENARIO_STEPS.createRubricSidePanel,
      RUBRIC_LIBRARY_SCENARIO_STEPS.myRubricTab,
    ];
  },
};

const CREATE_RUBRIC_FROM_FILE_SCENARIO_STEPS = {
  get uploadOrImport() {
    return {
      element: '[data-testid="create-rubric-from-file-upload-or-import"]',
      popover: {
        title: i18n.t("onboarding.rubricLibrary.uploadRubric.title"),
        description: i18n.t(
          "onboarding.rubricLibrary.uploadRubric.description"
        ),
        side: "top",
        align: "center",
      },
    };
  },
};

const CREATE_RUBRIC_FROM_FILE_SCENARIO = {
  get steps() {
    return [CREATE_RUBRIC_FROM_FILE_SCENARIO_STEPS.uploadOrImport];
  },
};

const RUBRIC_BUILDER_SCENARIO = {
  get steps() {
    return [
      {
        element: '[data-testid="rubric-builder-flexible-scoring"]',
        popover: {
          ...START_GRADING_SCENARIO_STEPS.gradingDetailsFlexibleScoring.popover,
          align: "start",
        },
      },
      {
        element: '[data-testid="rubric-builder-add-criteria"]',
        popover: {
          title: i18n.t("onboarding.rubricLibrary.addCriteria.title"),
          description: i18n.t(
            "onboarding.rubricLibrary.addCriteria.description"
          ),
          side: "left",
          align: "center",
        },
      },
      {
        element: '[data-testid="rubric-builder-add-score"]',
        popover: {
          title: i18n.t("onboarding.rubricLibrary.addScore.title"),
          description: i18n.t("onboarding.rubricLibrary.addScore.description"),
          side: "bottom",
          align: "center",
        },
      },
    ];
  },
};

export {
  RUBRIC_LIBRARY_SCENARIO_PAGE,
  RUBRIC_LIBRARY_SCENARIO_SIDEBAR,
  CREATE_RUBRIC_FROM_FILE_SCENARIO,
  CREATE_RUBRIC_FROM_FILE_SCENARIO_STEPS,
  RUBRIC_BUILDER_SCENARIO,
};
